import React, { Component, } from 'react';
import { arrayOf, object, string, } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Widget from '../../../../legacy-tv-ui/Widget';
import Table from '../../../../legacy-tv-ui/Table';
import Td from '../../../../legacy-tv-ui/Td';
import Tr from '../../../../legacy-tv-ui/Tr';
import Th from '../../../../legacy-tv-ui/Th';
import Return from '../../../../legacy-tv-ui/Return';
import Footnote from '../../../../components/Footnote';
import { toPercentage, } from '../../../../utils';

export class FundTable extends Component {
  static propTypes = {
    data: arrayOf(object),
    footnote: string,
    rebalance: object,
  }
  static defaultProps = {
    data: [],
    footnote: '',
    rebalance: { high: true, mid: true, low: true, },
  }
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { rebalance, } = this.props;
    return (
      <Grid
        item
        xs={12}
        style={{
          padding: 20,
        }}
      >
        <Widget
          title="投資組合"
        >
          <Table style={{ width: '100%', }}>
            <thead>
              <Tr>
                <Th>基金編號</Th>
                <Th style={{ width: 400, }}>基金名稱</Th>
                <Th>High</Th>
                <Th>權重差</Th>
                <Th>Mid</Th>
                <Th>權重差</Th>
                <Th>Low</Th>
                <Th>權重差</Th>
              </Tr>
            </thead>
            <tbody>
              {
                this.props.data.map((datum, idx) => (
                  <Tr key={datum.fund_id}>
                    <Td
                      style={{ textAlign: 'center', width: 60, }}
                    >
                      {datum.fund_id}
                    </Td>
                    <Td>
                      {datum.name}
                    </Td>
                    {
                      rebalance.high
                        ? [
                          <Td
                            style={{ textAlign: 'center', }}
                          >
                            {toPercentage(datum.high)}
                          </Td>,
                          <Td
                            style={{ textAlign: 'center', width: 60, background: '#f9f9f9', }}
                          >
                            <Return
                              rtn={datum.highAdj}
                            />
                          </Td>,
                        ]
                        : idx === 0
                          ? [
                            <Td
                              style={{ textAlign: 'center', }}
                              colSpan="2"
                              rowSpan={this.props.data.length + ''}
                            >
                              本月投組無rebalance
                            </Td>,
                          ]
                          : null
                    }
                    {
                      rebalance.mid
                        ? [
                          <Td
                            style={{ textAlign: 'center', }}
                          >
                            {toPercentage(datum.mid)}
                          </Td>,
                          <Td
                            style={{ textAlign: 'center', width: 60, background: '#f9f9f9', }}
                          >
                            <Return
                              rtn={datum.midAdj}
                            />
                          </Td>,
                        ]
                        : idx === 0
                          ? [
                            <Td
                              style={{ textAlign: 'center', }}
                              colSpan="2"
                              rowSpan={this.props.data.length + ''}
                            >
                              本月投組無rebalance
                            </Td>,
                          ]
                          : null
                    }
                    {
                      rebalance.low
                        ? [
                          <Td
                            style={{ textAlign: 'center', }}
                          >
                            {toPercentage(datum.low)}
                          </Td>,
                          <Td
                            style={{ textAlign: 'center', width: 60, background: '#f9f9f9', }}
                          >
                            <Return
                              rtn={datum.lowAdj}
                            />
                          </Td>,
                        ]
                        : idx === 0
                          ? [
                            <Td
                              style={{ textAlign: 'center', }}
                              colSpan="2"
                              rowSpan={this.props.data.length + ''}
                            >
                              本月投組無rebalance
                            </Td>,
                          ]
                          : null
                    }
                  </Tr>
                ))
              }
            </tbody>
          </Table>
          {
            this.props.footnote &&
            <Footnote>{this.props.footnote}</Footnote>
          }
        </Widget>
      </Grid>
    );
  }
}

export default FundTable;



// WEBPACK FOOTER //
// ./src/scenes/Adjustment/components/FundTable/index.js